export default __webpack_public_path__ + "static/media/filter.0943b817.svg";